import { render, staticRenderFns } from "./bing-layer-component.vue?vue&type=template&id=1cdf06e4"
import script from "./bing-layer-component.vue?vue&type=script&lang=js"
export * from "./bing-layer-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports